import { SuggestionListItemNew, SuggestionsList } from './suggestions-list';
import { getProductElementIndex } from './utils/get-element-index';
import React from 'react';
import { NewSuggestion } from 'types/suggestions';
import { useSuggestionsButtonAction } from '../hooks/use-suggestions-button-action';
import { useTranslation } from 'react-i18next';

const DATA_QA_NEW_SUGGESTIONS_LIST = 'new-suggestions';

type NewSuggestionsListProps = {
  showProducts: boolean;
  suggestionSelector: string;
  isDefaultList: boolean;
  slicedNewSuggestions: NewSuggestion[];
  index: number;
  buttonAction: ReturnType<typeof useSuggestionsButtonAction>;
  isSrp: boolean;
  showOnlyCategories: boolean;
  akinatorOffset: number;
  defaultListPinnedOffset: number;
  itemIndexOffset?: number;
};

export const NewSuggestionsList: React.FC<NewSuggestionsListProps> = ({
  showProducts,
  suggestionSelector,
  slicedNewSuggestions,
  isDefaultList,
  index,
  isSrp,
  buttonAction,
  showOnlyCategories,
  akinatorOffset,
  defaultListPinnedOffset,
  itemIndexOffset = 0,
}) => {
  const { t } = useTranslation();

  if (!showOnlyCategories && showProducts && slicedNewSuggestions.length > 0) {
    return (
      <SuggestionsList
        suggestionSelector={suggestionSelector}
        aria-label={t('header.searchbar.products-aria')}
        data-qa={DATA_QA_NEW_SUGGESTIONS_LIST}
      >
        {slicedNewSuggestions.map((item, idx) => (
          <SuggestionListItemNew
            newSuggestion={item}
            elementIndex={getProductElementIndex(
              idx,
              isDefaultList,
              akinatorOffset,
              defaultListPinnedOffset,
              itemIndexOffset,
            )}
            navigationIndex={index}
            buttonAction={buttonAction}
            isSrp={isSrp}
            suggestionSelector={suggestionSelector}
            key={item.name}
          />
        ))}
      </SuggestionsList>
    );
  } else {
    return null;
  }
};
